<template>
  <div class="header">
    <div>
      <span>{{ header.text }}</span>
      <div v-if="isRating" class="rating">
        <span>{{ header.rating }}</span>
        <StarsRating
          :rating="header.rating"
          :size="14"
          :offset="1"
          :totalStars="1"
        />
      </div>
    </div>
    <div v-if="showSort" class="header__sort-btn" @click="sort(header)">
      <v-icon size="20" :class="{ active: arrowUpActive }"
        >icon-arrow-thin-up</v-icon
      >
      <v-icon size="20" class="arrow-down" :class="{ active: arrowDownActive }"
        >icon-arrow-thin-up</v-icon
      >
    </div>
  </div>
</template>

<script>
import StarsRating from "@/components/ui/StarsRating";

export default {
  name: "ReviewsAnalystComparisonTableHeader",
  components: {
    StarsRating
  },

  props: {
    header: {
      type: Object,
      required: true
    },
    sortEnabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    arrowUpActive() {
      return this.header.sortDesc === false;
    },
    arrowDownActive() {
      return this.header.sortDesc === true;
    },
    isRating() {
      return this.header.rating !== undefined;
    },
    showSort() {
      return this.sortEnabled && this.header.sortable;
    }
  },

  methods: {
    sort(header) {
      this.$emit("sort", { header });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  span {
    display: flex;
    max-width: 50px;
  }

  &__sort-btn {
    cursor: pointer;
  }
}

.active {
  color: $primary !important;
}

.rating {
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 5px;
  padding: 0 $spacing * 0.5;
}

.arrow-down {
  transform: rotate(180deg);
}
</style>
